// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"157":"52029f4f8894460edab4","192":"73897fb3a6297c80182f","336":"8309848517bd793407d1","538":"e72beae4a76f14820fa0","607":"237b88a9d186588f26ca"}[chunkId] + ".min.js";
};